import { useEffect, useRef, useState } from "react";
import { getSearchStore, type SearchStoreValue } from "../../stores/searchStore";

/**
 * Hook that subscribes to the search store and returns the current state.
 * Simplifies store subscription pattern by managing the subscription lifecycle.
 *
 * @returns Current search store state
 */
export function useSearchStore() {
	const searchStoreRef = useRef(getSearchStore());
	const [state, setState] = useState<SearchStoreValue>(() => {
		const initialState = searchStoreRef.current.get?.();
		return initialState ?? { q: "", inputValue: "" };
	});

	useEffect(() => {
		const store = searchStoreRef.current;
		const unsubscribe = store.subscribe((newState: SearchStoreValue) => {
			setState(newState);
		});

		return unsubscribe;
	}, []);

	return state;
}
